import { createContext, useContext } from "react";

import type { ProductOptionFormModel } from "../../../model/type";

type QueryData = ProductOptionFormModel["QueryData"];
type ViewModel = ProductOptionFormModel["ViewModel"];

export type ProductOptionFormModelContextType = {
	viewModel: ViewModel;
	onSetViewModel: <K extends keyof ViewModel>(values: { key: K; value: ViewModel[K] }[]) => void;

	queryData: QueryData;
};

export const ProductOptionFormModelContext = createContext<ProductOptionFormModelContextType | null>(null);

export const useProductOptionFormModelContext = () => {
	const context = useContext(ProductOptionFormModelContext);

	if (!context) {
		throw new Error(
			"useProductOptionFormModelContext must be used within a ProductOptionFormModelContext.Provider",
		);
	}

	return context;
};
